'use client';

import { createContext } from 'react';

/** Interaction state shared by the flowchart canvas, its nodes, and its edges. */
export interface FlowchartHoverState {
  hoveredNodeId: string | null;
  hoveredConnectedNodeIds: Set<string>;
  focusedNodeId: string | null;
  focusedNodeIds: Set<string>;
}

const EMPTY_NODE_IDS: Set<string> = new Set<string>();

export const FLOWCHART_HOVER_DEFAULT: FlowchartHoverState = {
  hoveredNodeId: null,
  hoveredConnectedNodeIds: EMPTY_NODE_IDS,
  focusedNodeId: null,
  focusedNodeIds: EMPTY_NODE_IDS,
};

export const FlowchartHoverContext = createContext<FlowchartHoverState>(FLOWCHART_HOVER_DEFAULT);
